












































import { Component, Vue } from 'vue-property-decorator';
import authService from '../services/auth';
import db, {firebaseApp} from "@/plugins/firebase";
import {asyncFilter} from "@/util/common";
import {routes} from "@/router";

@Component({})
export default class Login extends Vue {
    showPassword = false;

    email = ''
    password = ''

    loading = false

    async login() {
      this.loading = true
      await firebaseApp.auth().signInWithEmailAndPassword(this.email,this.password)
      const uid = firebaseApp.auth().currentUser?.uid
      if(!uid) return null;
      const user = (await db.collection('administrators').doc(uid).get()).data() as User
      this.$store.commit("auth/user", user);
      const rts = await asyncFilter(
        routes, async r => {
          return r.meta?.drawer && await authService.canNavigate(r.meta?.authority,user)
        });
      this.loading = false
      this.$router.push(rts[0])
    }
}
